import React from 'react';
import Circle from '../Circle';
import PlusIcon from '../../icons/utility/PlusIcon';
const PlusCircle = ({ size = 'regular', disabled = false, styles }) => {
    const iconSizeProps = size === 'tiny'
        ? { width: '80%', height: '80%', x: '10%', y: '10%' }
        : { width: '50%', height: '50%', x: '25%', y: '25%' };
    return (React.createElement(Circle, { kind: "regular", size: size, styles: styles, disabled: disabled },
        React.createElement(PlusIcon, { size: "small", ...iconSizeProps, disabled: disabled })));
};
export default PlusCircle;
//# sourceMappingURL=index.js.map